import { useQuery, gql, useLazyQuery } from '@apollo/client';
import { PeriodosQuery } from './__generated__/PeriodosQuery';

const PERIODOS_QUERY = gql`
  query PeriodosQuery {
    periodos {
      id_periodo
      dsc_periodo
      dat_inicio
      dat_fim
    }
  }
`;

const usePeriodosQuery = () => {
  return useQuery<PeriodosQuery>(PERIODOS_QUERY);
};

const usePeriodosLazyQuery = () => {
  return useLazyQuery<PeriodosQuery>(PERIODOS_QUERY);
};

export { usePeriodosQuery, usePeriodosLazyQuery };
